<template>
  <div>
    <v-form>
      <!-- forms -->
      <Credit
        @update="formUpdated"
        @validate="validate"
      />
      <v-btn
        color="red"
        dark
        @click="$router.go(-1)"
      >
        Back
      </v-btn>
      <v-btn
        :disabled="!valid"
        :loading="isProcessing"
        @click="submit"
      >
        Submit Payment
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import Credit from './Credit'
export default {
  components: {
    Credit
  },
  props: {
    amount: {
      type: Number,
      default: 0
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: false,
      currentFormData: null
    }
  },
  methods: {
    formUpdated (formData) {
      this.currentFormData = formData
    },
    validate (valid) {
      this.valid = valid
    },
    submit () {
      let paymentData = {
        paymentTypeID: 'creditCard',
        amount: this.amount,
        ...this.currentFormData
      }
      this.$emit('submit', paymentData)
    }
  }
}
</script>
